
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-abroad-consultants-in-chandigarh",
      function () {
        return require("private-next-pages/study-abroad-consultants-in-chandigarh.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-abroad-consultants-in-chandigarh"])
      });
    }
  